import React, { useState } from 'react';
import logo from "./logo-s.png"; // Adjust the path to your logo image

import jsPDF from "jspdf";

const questions = [
    {
      question: "Do you smoke?",
      options: ["Yes", "No"],
      points: [2, 0],
      effect: "Smoking is a well-known factor for reducing life expectancy.",
      suggestion: "Consider quitting smoking. It significantly improves your health."
    },
    {
      question: "Do you consume alcohol regularly?",
      options: ["Yes", "No"],
      points: [0.50, 0],
      effect: "Excessive alcohol consumption has various health implications, especially for the liver and heart.",
      suggestion: "Reduce alcohol consumption for better health outcomes."
    },
    {
      question: "Do you have a family history of heart disease?",
      options: ["Yes", "No"],
      points: [1.5, 0],
      effect: "Genetics play a role in many health conditions, including heart disease.",
      suggestion: "Consider regular check-ups and a heart-healthy lifestyle."
    },
    {
      question: "Do you have any cardiovascular diseases (like Heart Attack, Stroke, or Clotting)?",
      options: ["Yes", "No"],
      points: [2, 0],
      effect: "Cardiovascular diseases can significantly reduce life expectancy.",
      suggestion: "Consider consulting with a healthcare provider and making lifestyle changes to manage cardiovascular risks."
    },
    {
      question: "Do you have any symptoms of cancer (like Lung, Colon, Breast, or Pancreatic)?",
      options: ["Yes", "No"],
      points: [2, 0],
      effect: "Cancer symptoms can impact life expectancy if left untreated.",
      suggestion: "Seek medical attention for early diagnosis and better management options."
    },
    {
      question: "Do you have any infectious diseases (like HIV/AIDS, TB, or Malaria)?",
      options: ["Yes", "No"],
      points: [2, 0],
      effect: "Infectious diseases can reduce life expectancy if not treated promptly.",
      suggestion: "Consult with a healthcare provider to manage and treat infectious diseases effectively."
    },
    {
      question: "Do you have any chronic diseases (like Diabetes, Kidney Disease, or Liver Disease)?",
      options: ["Yes", "No"],
      points: [1.5, 0],
      effect: "Chronic diseases can impact longevity if not managed well.",
      suggestion: "Consider adopting a healthy lifestyle and regular check-ups to manage chronic diseases."
    },
    {
          question: "Have you ever thought about suicide?",
          options: ["Yes", "No"],
          points: [1, 0],
          effect: "Thinking about suicide can be a sign of severe distress and mental health issues.",
          suggestion: "If you are feeling overwhelmed, please talk to someone you trust or a mental health professional.\nCall [+91 9152987821] for immediate support.",
          popup: {
            message: "Think about your Mother Before Commiting Suside\n Never give up! Life has so much to offer, and there is always hope. Please reach out for help.\nCall [+91 9152987821] for immediate support. ",
            helpline: "Call [+91 9152987821] for immediate support."
          }
        },
        {
          question: "Are you generally happy with your life?",
          options: ["Yes", "No"],
          points: [0, 0.5],
          effect: "Dissatisfaction with life can lead to feelings of hopelessness and despair.",
          suggestion: "Consider discussing your feelings with someone who can help you explore ways to improve your happiness."
        },
        {
          question: "Do you believe you have strong willpower?",
          options: ["Yes", "No"],
          points: [0, 0.8],
          effect: "Having strong willpower is essential for overcoming challenges and pursuing goals.",
          suggestion: "Reflect on your strengths and consider setting small, achievable goals to enhance your willpower."
        },
        {
          question: "Do you have strong emotional connections with your family?",
          options: ["Yes", "No"],
          points: [0, 0.8],
          effect: "Strong family relationships can provide support and resilience during tough times.",
          suggestion: "If your family relationships are strained, consider reaching out to family members to foster connection and communication."
        },
        {
          question: "Are you satisfied with your life overall?",
          options: ["Yes", "No"],
          points: [0, 0.3],
          effect: "Feeling unsatisfied with life can contribute to mental health issues.",
          suggestion: "Reflect on what aspects of your life you would like to change and consider seeking guidance to make positive changes."
    },
     
      
    {
      question: "Do you sleep enough time as required?",
      options: ["<5 hours", "5-6 hours", "7-8 hours", ">8 hours"],
      points: [1.5, 1, 0, 1],
      effect: "Poor or irregular sleep patterns are strongly linked to health issues.",
      suggestion: "Aim for 7-9 hours of quality sleep each night to improve your overall health."
    },
    {
      question: "Do you suffer from any sleep disorders, such as insomnia or sleep apnea?",
      options: ["Yes", "No"],
      points: [0.5, 0],
      effect: "Sleep disorders can contribute to high blood pressure, heart disease, and other serious conditions.",
      suggestion: "Consult a healthcare professional for diagnosis and treatment options."
    },
    {
      question: "Do you live in a highly polluted environment?",
      options: ["Yes", "No"],
      points: [0.8, 0],
      effect: "Pollution can lead to respiratory diseases and lower life expectancy.",
      suggestion: "Take steps to minimize exposure to pollution and consider moving if possible."
    },
    {
      question: "Do you have access to clean drinking water and hygienic living conditions?",
      options: ["Yes", "No"],
      points: [0, 1],
      effect: "Access to clean water and sanitation are key to overall health.",
      suggestion: "If you lack access, consider seeking resources to improve your living conditions."
    },
    {
      question: "Do you wear a seatbelt every time you drive?",
      options: ["Yes", "No"],
      points: [0, 2],
      effect: "Seatbelt usage significantly reduces fatality risks in accidents.",
      suggestion: "Always wear a seatbelt and ensure all passengers do the same."
    },
    {
      question: "Do you speed while driving?",
      options: ["Yes", "No"],
      points: [2, 0],
      effect: "Speeding increases the likelihood of fatal accidents.",
      suggestion: "Observe speed limits to ensure your safety and the safety of others on the road."
    },
    {
      question: "Have you been involved in any serious accidents in the last 5 years?",
      options: ["Yes", "No"],
      points: [2, 0],
      effect: "Past accidents could indicate high-risk driving habits.",
      suggestion: "Consider taking a defensive driving course to improve your driving skills."
    },
    {
      question: "Do you experience high levels of stress on a daily basis?",
      options: ["Yes", "No"],
      points: [1.3, 0],
      effect: "Chronic stress has a major impact on mental and physical health, leading to shorter lifespans.",
      suggestion: "Practice stress-relief techniques such as mindfulness or meditation."
    },
    {
      question: "Do you work in a high-risk occupation?",
      options: ["Yes", "No"],
      points: [0.6, 0],
      effect: "Dangerous working environments can increase the likelihood of life-threatening accidents.",
      suggestion: "Ensure you have proper safety training and equipment to mitigate risks."
    },
    {
      question: "Do you have a balanced work-life routine?",
      options: ["Yes", "No"],
      points: [0, 0.4],
      effect: "An unbalanced routine may lead to burnout, stress, and associated health problems.",
      suggestion: "Prioritize time for relaxation and personal activities to improve balance."
    },
    {
      question: "Do you have a strong social support network?",
      options: ["Yes", "No"],
      points: [0, 0.3],
      effect: "Studies have shown that people with strong social networks tend to live longer.",
      suggestion: "Make an effort to connect with family and friends to strengthen your support network."
    },
    {
      question: "Do you regularly engage in hobbies or activities that you enjoy?",
      options: ["Yes", "No"],
      points: [0, 0.1],
      effect: "Having hobbies and interests contributes to mental well-being and longevity.",
      suggestion: "Find time to engage in hobbies to enhance your mental health and happiness."
    },
    {
      question: "Do you use recreational drugs (e.g., marijuana, cocaine)?",
      options: ["Yes", "No"],
      points: [1.5, 0],
      effect: "Substance abuse can lead to various health complications and early death.",
      suggestion: "Consider seeking help or resources to reduce or eliminate substance use."
    },
    {
      question: "Do you consume caffeinated beverages (coffee, tea, energy drinks)?",
      options: ["Never", "Occasionally", "Daily"],
      points: [0, 0.7, 1],
      effect: "Excessive caffeine consumption can contribute to sleep disorders, stress, and heart issues.",
      suggestion: "Moderate your caffeine intake to maintain healthy sleep patterns."
    },
    {
      question: "Do you use protective gear (helmet, safety shoes, etc.) at work or while riding?",
      options: ["Yes", "No"],
      points: [0, 2],
      effect: "Use of protective gear significantly reduces the chances of fatal accidents.",
      suggestion: "Always use appropriate protective gear in hazardous environments."
    },
    {
      question: "Do you have regular health checkups?",
      options: ["Yes", "No"],
      points: [0, 1],
      effect: "Regular health monitoring helps detect issues early, improving chances of survival in the long run.",
      suggestion: "Schedule regular health checkups to monitor your health status."
    },
    {
      question: "Do you own a firearm or other dangerous weapons?",
      options: ["Yes", "No"],
      points: [1, 0],
      effect: "Firearms in the home can increase the likelihood of accidental deaths.",
      suggestion: "Consider safely storing or removing firearms from your home."
    },
    {
      question: "Do you practice self-care (meditation, relaxation)?",
      options: ["Yes", "No"],
      points: [0, 0.8],
      effect: "Self-care practices contribute to better mental and physical health, which can prolong life.",
      suggestion: "Incorporate self-care routines into your daily life for improved well-being."
    },
    {
      question: "Do you follow your doctor's advice regarding health recommendations?",
      options: ["Yes", "No"],
      points: [0, 1],
      effect: "Compliance with medical advice is crucial for managing chronic conditions and preventing early death.",
      suggestion: "Make a commitment to follow your healthcare provider's recommendations."
    }
  ]
  
  const Questionnaire = () => {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [responses, setResponses] = useState(Array(questions.length).fill(null));
    const [totalPoints, setTotalPoints] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [userAge, setUserAge] = useState("");
    const [gender, setGender] = useState("");
    const [countryType, setCountryType] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [userName, setUserName] = useState(""); // State for user's name
    const [showNameInput, setShowNameInput] = useState(false); // State for showing input field
  
    const handleChange = (index, value) => {
      const newResponses = [...responses];
      newResponses[index] = value;
      setResponses(newResponses);
    };
  
    const handleNext = () => {
      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
      }
    };
  
    const handlePrev = () => {
      if (currentQuestion > 0) {
        setCurrentQuestion(currentQuestion - 1);
      }
    };
  
    const handleSubmit = () => {
      let points = 0;
      let userSuggestions = [];
  
      responses.forEach((response, index) => {
        if (response !== null) {
          points += questions[index].points[response];
          if (response === 0) {
            userSuggestions.push(questions[index].suggestion);
          }
          // Handle popup message
          if (response === 0 && questions[index].popup) {
            setPopupMessage(questions[index].popup.message);
            setShowPopup(true);
          }
        }
      });
  
      setTotalPoints(points);
      setSuggestions(userSuggestions);
      setSubmitted(true);
    };
  
    const getRiskPercentage = (points) => {
      const maxPoints = questions.reduce(
        (total, question) => total + Math.max(...question.points),
        0
      );
      return Math.round((points / maxPoints) * 100);
    };
  
    const handleFinalSubmit = () => {
      let lifeExpectancy;
      if (gender === "Male") {
        lifeExpectancy =
          countryType === "Developed" ? 74.8 : countryType === "Less Developed" ? 63 : 74.8;
      } else if (gender === "Female") {
        lifeExpectancy =
          countryType === "Developed" ? 80.2 : countryType === "Less Developed" ? 66 : 79;
      }
  
      const remainingYears = lifeExpectancy - userAge;
      alert(`You have approximately ${remainingYears} years remaining.`);
    };
  
    // New function to download the PDF
    const downloadPDF = () => {
      const doc = new jsPDF();
      const riskPercentage = getRiskPercentage(totalPoints);
  
      // Add logo image
      const img = new Image();
      img.src = logo;
      img.onload = () => {
        // Calculate position to center the logo
        const logoWidth = 40; // Width of the logo
        const logoHeight = 20; // Height of the logo
        const logoX = (doc.internal.pageSize.width - logoWidth) / 2; // Center the logo horizontally
        const logoY = 10; // Keep the logo at 10 units from the top
  
        // Add logo with specified width and height
        doc.addImage(img, "PNG", logoX, logoY, logoWidth, logoHeight); // Position and size of the logo
  
        // Set font size for the title and center it
        doc.setFontSize(18);
        const title = "Risk Assessment Report";
        const titleWidth = doc.getTextWidth(title);
        doc.text(title, (doc.internal.pageSize.width - titleWidth) / 2, 40); // Center the title
  
        // Add the user's name at the top
        doc.setFontSize(12);
        doc.text(`Dear ${userName}, `, 10, 55); // Position for user's name
  
        // Add description about the predictor
        const description = "Death Predictor made by Webmafiya";
        doc.setFontSize(12);
        const descriptionWidth = doc.getTextWidth(description);
        doc.text(description, (doc.internal.pageSize.width - descriptionWidth) / 2, 65); // Center the description
  
        // Add Instagram follow request below the description
        const followText = "Follow us on Instagram: @webmafiya";
        const followTextWidth = doc.getTextWidth(followText);
        doc.text(followText, (doc.internal.pageSize.width - followTextWidth) / 2, 75); // Center the follow request
  
        // Set font size for the content to 16
        doc.setFontSize(10);
  
        // Add total points and risk percentage above the suggestions
        let contentY = 85; // Start position for content
        doc.text(`Total Points: ${totalPoints}`, 10, contentY); // Adjust position for total points
        contentY += 10; // Increment Y for next line
        doc.text(`Risk Percentage: ${riskPercentage}%`, 10, contentY); // Adjust position for risk percentage
        contentY += 20; // Increment Y for suggestions
  
        // Check for suggestions and ensure all text is visible
        if (suggestions.length > 0) {
          doc.text("Your Suggestions:", 10, contentY); // Align left
          contentY += 10; // Increment Y for next line
  
          suggestions.forEach((suggestion, index) => {
            // Check if we need to add a new page if content exceeds page height
            if (contentY + 10 > doc.internal.pageSize.height - 20) {
              doc.addPage(); // Add a new page
              contentY = 10; // Reset Y position for new page
            }
            doc.text(`${index + 1}. ${suggestion}`, 10, contentY); // Align left
            contentY += 10; // Increment Y for next suggestion
          });
        } else {
          doc.text("No suggestions available.", 10, contentY); // Align left
        }
  
        // Save the PDF
        doc.save("Risk_Assessment_Report.pdf");
      };
    };
  
    return (
      <div className="w-full max-w-lg lg:max-w-3xl sm:w-3xl mx-auto p-4 bg-gray-900 text-white shadow-lg rounded-lg overflow-y-auto max-h-[80vh]">
        <h2 className="text-2xl font-bold mb-2 text-center text-blue-500 transition-colors">
          Death Predictor
        </h2>
        {!submitted ? (
          <div>
            <div key={currentQuestion} className="mb-4">
              <p className="font-semibold">{questions[currentQuestion].question}</p>
              {questions[currentQuestion].options.map((option, i) => (
                <label key={i} className="block">
                  <input
                    type="radio"
                    name={`question${currentQuestion}`}
                    value={i}
                    checked={responses[currentQuestion] === i}
                    onChange={() => handleChange(currentQuestion, i)}
                    className="mr-2"
                  />
                  {option}
                </label>
              ))}
              <p className="text-sm text-gray-400 mt-2">{questions[currentQuestion].effect}</p>
            </div>
  
            <div className="flex justify-between mt-4">
              <button
                onClick={handlePrev}
                className="bg-gray-700 text-white p-2 rounded hover:bg-gray-600 transition-colors"
                disabled={currentQuestion === 0}
              >
                Previous
              </button>
              {currentQuestion < questions.length - 1 ? (
                <button
                  onClick={handleNext}
                  className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition-colors"
                  disabled={responses[currentQuestion] === null}
                >
                  Next
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition-colors"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="text-left">
            <h3 className="text-xl font-bold">Your Risk Assessment</h3>
            <p>Your total points: {totalPoints}</p>
            <p>Risk Percentage: {getRiskPercentage(totalPoints)}%</p>
            <p className="mt-2 text-red-400">
              Lower scores indicate a longer predicted lifespan, while higher scores suggest risk
              factors that may reduce life expectancy. 10% = 1 Year. Remaining age - (10% = 1) =
              More Accurate Remaining Age Prediction.
            </p>
  
            {/* Show popup for specific messages */}
            {showPopup && (
              <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
                <div className="bg-white text-black p-4 rounded shadow-md">
                  <p>{popupMessage}</p>
                  <button
                    onClick={() => setShowPopup(false)}
                    className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
  
            <h3 className="text-lg font-semibold mt-4">Suggestions:</h3>
            {suggestions.length > 0 && (
              <div className="mt-4 max-h-56 overflow-y-auto">
                <h4 className="font-semibold">Your Suggestions:</h4>
                <ul className="list-disc ml-5">
                  {suggestions.map((suggestion, index) => (
                    <li key={index}>{suggestion}</li>
                  ))}
                </ul>
                <p className="mt-4 text-green-500 text-sm">
                  Note: A higher score leads to a higher chance of dying early. These results are
                  based on scientific facts and research.
                </p>
              </div>
            )}
  
            {/* Input field for user's name */}
            {!showNameInput && (
              <button
                onClick={() => setShowNameInput(true)}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
              >
                Enter Name & Download Report
              </button>
            )}
  
            {showNameInput && (
              <div className="mt-4">
                <input
                  type="text"
                  placeholder="Your Name"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  className="p-2 border text-black border-gray-300 rounded w-full"
                />
                <button
                  onClick={downloadPDF}
                  className="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
                  disabled={!userName}
                >
                  Download PDF
                </button>
              </div>
            )}
  
            <div className="flex flex-col mt-4">
              <label className="mb-1">Age:</label>
              <input
                type="number"
                value={userAge}
                onChange={(e) => setUserAge(e.target.value)}
                className="p-2 border text-black border-gray-300 rounded mb-2"
                placeholder="Enter your age"
              />
  
              <label className="mb-1">Gender:</label>
              <select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="p-2 border text-black border-gray-300 rounded mb-2"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
  
              <label className="mb-1">Country Type:</label>
              <select
                value={countryType}
                onChange={(e) => setCountryType(e.target.value)}
                className="p-2 border text-black border-gray-300 rounded mb-2"
              >
                <option value="">Select Country Type</option>
                <option value="Developed">Developed</option>
                <option value="Developing">Developing</option>
                <option value="Less Developed">Less Developed</option>
              </select>
  
              <button
                onClick={handleFinalSubmit}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                disabled={!userAge || !gender || !countryType}
              >
                Calculate Remaining Years
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default Questionnaire;
  